module.exports = __webpack_public_path__ + "static/img/fastProduct.c6efa52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/fastProduct.jpg
// module id = /j6H
// module chunks = 1